import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit {
    formVer: FormGroup;
    url: string;
    rol: string;

    envioCorreo: boolean;
    mensajeExito: string;
    mensajeError: string;
    mensajeUsuarioNull: string;

    constructor(private formBuldier: FormBuilder, private cdr: ChangeDetectorRef,
        private usuarioService: UsuarioService, private router: Router, private title: Title, private meta: Meta) {
            this.agregarMetaData();
            this.url = this.router.url
     }

    ngOnInit() {
      this.formVer = this.formBuldier.group({
          token: [null,[Validators.required]]
      })
    }

    private agregarMetaData(): void {
        this.title.setTitle('Verificar Cuenta');
        this.meta.updateTag({name: "description", content: "Ingresa tu código de verificación y comienza con las postulaciones y búsqueda de mejores talentos y ofertas laborales."});//falta descripcion e imagen para mostrar en open graph
        this.meta.updateTag({name: "keywords", content: "registro, empresas, candidatos, cuenta, verificar"});
        this.meta.updateTag({name: "robots", content: "noodp"});
        this.meta.updateTag({property: "og:title", content: "Verificar Cuenta"});
        this.meta.updateTag({property: "og:description", content: "Ingresa tu código de verificación y comienza con las postulaciones y búsqueda de mejores talentos y ofertas laborales."});
        this.meta.updateTag({property: "og:url", content: environment.baseTG});
        this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
        this.meta.updateTag({property: "og:locale", content: "es_ES"});
        this.meta.updateTag({property: "og:type", content: "website"});
        this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
        this.meta.updateTag({name: "twitter:title", content: "Verificar Cuenta"});
        this.meta.updateTag({name: "twitter:description", content:"Ingresa tu código de verificación y comienza con las postulaciones y búsqueda de mejores talentos y ofertas laborales."});
        this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
        this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
        this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
        this.meta.updateTag({name: "twitter:card", content: "summary"});
      }

    verificarCuenta(){
      if(this.formVer.valid){
          const token: string = this.formVer.value.token.trim();
          this.rol = this.url.slice(11)
          this.usuarioService.verificarCuenta(token, this.rol).pipe(
              catchError(error => {
                  let mensajeError = '';
                  if (error.status === 0) {
                      mensajeError = 'Error: se ha producido un error: '+ error.error + '/n'
                      mensajeError += `Http error: ${error.message}`;
                      console.error('se ha producido un error:', error.error);
                  }else{
                      mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.messageError}.\n`;
                      mensajeError += `Http error: ${error.message}`;
                      this.mensajeUsuarioNull = error.error.message;
                      setTimeout(() => {
                          this.mensajeUsuarioNull = "" as string;
                        }, 4000);
                      console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
                  }
                  this.mensajeError = mensajeError;
                  setTimeout(() => {
                   this.mensajeError = "" as string;
                  }, 4000);
                  return throwError(mensajeError);
              })
          ).subscribe(result => {
              this.envioCorreo = true;
              if(result.success){
                  this.mensajeExito = 'Éxito se ha verificado tu cuenta ya puede Iniciar Sesión';
                  setTimeout(() => {
                      this.mensajeExito = "" as string;
                      this.router.navigate(['/acceder']);
                    }, 4000);
              }else{
                  this.mensajeExito = result.messageError;
                  console.error('Error verificar cuenta: ', result.messageError);
              }
          });
      }
    }

}
